import { GameCard } from '@/features/games/shared/components/game-card';
import { Carousel } from '@/shared/components/carousel';
import { GameCardData } from '@/features/games/internal/types/game-card-data';

export const GameCardCarousel = ({
  title,
  games,
  subtitle,
  perPage = { sm: 2, md: 6, lg: 6 },
  imageSize = 'square',
  showPrice = false,
  showSubtitle = false,
  showCategory = true,
  onSale,
  hideSeperators = false,
  className,
  showRating = false,
}: {
  title: string;
  games: GameCardData[];
  subtitle?: string;
  perPage?: {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    '2xl'?: number;
  };
  imageSize?: 'tall' | 'wide' | 'square';
  showPrice?: boolean;
  showSubtitle?: boolean;
  showCategory?: boolean;
  onSale?: boolean;
  hideSeperators?: boolean;
  className?: string;
  showRating?: boolean;
}) => {
  if (games.length === 0) {
    return null;
  }

  const items = games.map((game) => (
    <div
      key={game.id}
      className='relative top-0 h-full origin-center transition-[top] duration-200 ease-out focus-within:-top-1 hover:-top-1 motion-reduce:top-0'
    >
      <GameCard
        game={game}
        imageSize={imageSize}
        showCategory={showCategory}
        showPrice={showPrice}
        showSubtitle={showSubtitle}
        onSale={onSale}
        showRating={showRating}
        prefetchMode='full'
      />
    </div>
  ));

  return (
    <Carousel
      className={className}
      hideSeperators={hideSeperators}
      perPage={perPage}
      products={items}
      subTitle={subtitle!}
      title={title}
    />
  );
};
